import React from "react";

const Share = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path
      d="M22 11l-8-8v5C8.4 8 1 10.2 1 20c2.7-4.6 5.5-6 13-6v5l8-8z"
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Share;



// WEBPACK FOOTER //
// ./src/theme/icons/Share.js